<script>
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue';

import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue';
import GenericBooleanDropdownNull from '../../components/generic/GenericBooleanDropdownNull.vue';
import CommonService from '../../services/common';
import Service from '@/services/vessel-protocol';
import Utils from '../../common/Utils';


export default {
    components: {
        GenericCustomAutocompleteV2,ResponsiveButton, GenericBooleanDropdown, GenericBooleanDropdownNull
    },
    data(){
        return{
            configuration: null,
            winWidth: window.innerWidth,
            code: null,
            filters: {
                dueDateFrom: Utils.formatDatePlusDays(new Date(), -30),
                dueDateTo: new Date(),
                isPeriodicPayment: true,
                isSpecialPayment: false,
                isExecuted: false
            },

            paymentTypesValues: {
                POR_TAX: false,
                STAZ_SPER: false,
                VAT: false,
                INT: false,
                DAZ: false
            },
            paymentTypes: [
                { label: 'Tasse Portuali', value: 'POR_TAX'},
                { label: 'Stazione Sperimentale', value: 'STAZ_SPER'},
                { label: 'Iva', value: 'VAT'},
                { label: 'Interessi', value: 'INT'},
                { label: 'Dazio', value: 'DAZ'},
            ],
            data: [],
            loading: false
        }
    },
    created(){
        this.$store.dispatch('security/setNavbarTitle', 'VesselProtocolTributeSearch.page_title');
    },
    mounted(){
        window.addEventListener('resize', () => {
            this.winWidth = window.innerWidth;
        });
    },
    methods: {
        loadData(){ 

            this.data = [];
            this.loading = true;

            this.filters.paymentType = [];
            for (const key in this.paymentTypesValues) {
                if(this.paymentTypesValues[key]){
                    this.filters.paymentType.push(key);
                }
            }

            CommonService.createItem('vessel-protocol-payments-tribute-research', this.filters, response => {
                this.loading = false;
                if(response.success){
                    this.data = response.data;
                }
            })
        },
        openProtocol(data){
            let uri = `/vessel-protocol?id=${data.idMovementInstructionLot}`;
            this.$router.push(uri);
        },
        exportExcelTributeResearch(){           
            let fileName =  `Tribute_Research`;
            this.$store.dispatch("generic/setLoading", true);
            Service.tributeResearchExportExcel(this.filters, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.downloadDocument(response.data, fileName)
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        downloadDocument(id, name){
            let body = {
                id: id
            };

            Service.printTributeResearchExcel(body, ({success, data, message}) => {
                
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', name + '.xlsx');
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        }
    },
    computed: {
        utils(){
            return Utils;
        },
    }
}


</script>



<template>
    <div class="grid">
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('VesselProtocolTributeSearch.dateFrom') }}</label>
            <Calendar
                class="p-inputtext-sm w-full"
                placeholder="DD/MM/AAAA"
                v-model="filters.dueDateFrom"
                dateFormat="dd/mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('VesselProtocolTributeSearch.dateTo') }}</label>
            <Calendar
                class="p-inputtext-sm w-full"
                placeholder="DD/MM/AAAA"
                v-model="filters.dueDateTo"
                dateFormat="dd/mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <!-- <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocol.paymentType') }}</label>
            <MultiSelect v-model="filters.paymentType" :options="paymentTypes" optionLabel="label"  optionValue="value"  
                class="p-inputtext-sm w-full" />
        </div> -->
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocol.isPeriodicPayment') }}</label>
            <GenericBooleanDropdown 
                v-model="filters.isPeriodicPayment" 
                class="w-full" />
        </div>
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocol.isSpecialPayment') }}</label>
            <GenericBooleanDropdown 
                v-model="filters.isSpecialPayment" 
                class="w-full" />
        </div>
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocol.isExecuted') }}</label>
            <GenericBooleanDropdownNull 
                v-model="filters.isExecuted" 
                class="w-full" />
        </div>
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocol.customer') }}</label>
            <GenericCustomAutocompleteV2
                v-model="filters.customer"
                id="customer"
                :format=" { label: 'label', value: 'label' }"
                api="masterdata/company-combo"
                :queryField="{isOwner: true}"
                class="w-full p-inputtext-sm" />
        </div>
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocol.plant') }}</label>
            <GenericCustomAutocompleteV2
                v-model="filters.plant"
                id="plant"
                :format=" { label: 'label', value: 'label' }"
                api="masterdata/registry-plant-combo"
                class="w-full p-inputtext-sm" />
        </div>
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocolSearch.originCountry') }}</label>
            <GenericCustomAutocompleteV2 
                class="p-inputtext-sm w-full"
                v-model="filters.originCountry"
                :format="{ label: 'label', value: 'extraData' }"
                api="masterdata/country-and-territory-combo-list" />
          </div>
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocolSearch.destinationCountry') }}</label>
            <GenericCustomAutocompleteV2 
                class="p-inputtext-sm w-full"
                v-model="filters.destinationCountry"
                :format="{ label: 'label', value: 'extraData' }"
                api="masterdata/country-and-territory-combo-list" />
          </div>
        <div class="col-12 lg:col-3 field">
              <label>{{ $t('vesselProtocolSearch.voyageNumber') }}</label>
              <InputText 
                  class="p-inputtext-sm w-full"
                  v-model="filters.voyageNumber" />
        </div>
        <div class="col-12 lg:col-3 field">
              <label>{{ $t('vesselProtocol.a93Number') }}</label>
              <InputText 
                  class="p-inputtext-sm w-full"
                  v-model="filters.a93" />
          </div>
          
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocol.a93DateFrom') }}</label>
            <Calendar
                class="p-inputtext-sm w-full"
                placeholder="DD/MM/AAAA"
                v-model="filters.a93DateFrom"
                dateFormat="dd/mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
          
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocol.a93DateTo') }}</label>
            <Calendar
                class="p-inputtext-sm w-full"
                placeholder="DD/MM/AAAA"
                v-model="filters.a93DateTo"
                dateFormat="dd/mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-12 lg:col-3 field">
              <label>{{ $t('vesselProtocol.a98Number') }}</label>
              <InputText 
                  class="p-inputtext-sm w-full"
                  v-model="filters.a98" />
          </div>
          
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocol.a98DateFrom') }}</label>
            <Calendar
                class="p-inputtext-sm w-full"
                placeholder="DD/MM/AAAA"
                v-model="filters.a98From"
                dateFormat="dd/mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
          
        <div class="col-12 lg:col-3 field">
            <label>{{ $t('vesselProtocol.a98DateTo') }}</label>
            <Calendar
                class="p-inputtext-sm w-full"
                placeholder="DD/MM/AAAA"
                v-model="filters.a98To"
                dateFormat="dd/mm/yy" :showTime="false"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>

        <div class="col-12 lg:col-2 field" v-for="paym in paymentTypes" :key="paym.value">
            <!-- <Checkbox v-model="paymentTypesValues[paym.value]" :inputId="paym.value" name="paymentTypes" :value="paymentTypesValues[paym.value]" :trueValue="true" :falseValue="false" /> -->
            <Checkbox v-model="paymentTypesValues[paym.value]" :binary="true" />
            <label class="ml-2">{{paym.label}}</label>
        </div>

        <div class="col-6 lg:col-2" />
        
        <div class="col-12 lg:col-1">
            <ResponsiveButton :label="$t('btn.search')" icon="pi pi-search" class="p-button-outlined p-button-sm" @click="loadData()" />
        </div>

        <div class="col-12 lg:col-1">
            <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file-excel" class="p-button-outlined p-button-sm" @click="exportExcelTributeResearch()" />
        </div>
    </div>
    <div class="">
        <DataTable :value="data" :loading="loading"
        
        showGridlines stripedRows :scrollable="true"
        :responsiveLayout="'stack'"
        :scrollHeight="'flex'"
        class="p-datatable-sm" style="margin-top:20px;font-size:8px;">
            <Column style="width: 150px;">
                <template #body="slotProps">
                    <ResponsiveButton icon="pi pi-directions" v-tooltip="$t('movementInstructions.btn.vesselProtocol')" class="p-button-rounded p-button-outlined mr-1 mb-1" @click="openProtocol(slotProps.data)" />
                </template>
            </Column>
            <Column field="voyageNumber" :header="$t('vesselProtocol.voyageNumber')" sortable  style="width: 150px;"></Column>
            <Column field="paymentType" :header="$t('vesselProtocol.paymentType')" sortable style="width: 150px;"></Column>
            <Column field="isPeriodicPayment" :header="$t('vesselProtocol.isPeriodicPayment')" sortable style="width: 150px;">
                <template #body="element" >
                    {{element.data.isPeriodicPayment ? $t('yes'): $t('no')}}
                </template>
            </Column>
            <Column field="isSpecialPayment" :header="$t('vesselProtocol.isSpecialPayment')" sortable style="width: 150px;">
                <template #body="element" >
                    {{element.data.isSpecialPayment ? $t('yes'): $t('no')}}
                </template>
            </Column>
            <Column field="referenceDate" :header="$t('vesselProtocol.referenceDate')" sortable style="width: 150px;">
                <template #body="element" >
                    {{element.data.referenceDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data.referenceDate)) : null}}
                </template>
            </Column>
            <Column field="dueDate" :header="$t('vesselProtocol.dueDate')" sortable style="width: 150px;">
                <template #body="element" >
                    {{element.data.dueDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data.dueDate)) : null}}
                </template>
            </Column>
            <Column field="paymentDescription" :header="$t('vesselProtocol.paymentDescription')" sortable style="width: 150px;"></Column>
            <Column field="totalAmount" :header="$t('vesselProtocol.totalAmount')" sortable style="width: 150px;"></Column>
            <Column field="portualTax" :header="$t('VesselProtocolTributeSearch.portualTax')" sortable style="width: 150px;"></Column>
            <Column field="experimentalStationTotalAmount" :header="$t('vesselProtocol.experimentalStationTotalAmount')" sortable style="width: 150px;"></Column>
            <Column field="vatTotalAmount" :header="$t('vesselProtocol.vatTotalAmount')" sortable style="width: 150px;"></Column>
            <Column field="taxTotalAmount" :header="$t('vesselProtocol.taxTotalAmount')" sortable style="width: 150px;"></Column>
            <Column field="customDutiesTotalAmount" :header="$t('vesselProtocol.customDutiesTotalAmount')" sortable style="width: 150px;"></Column>
            
            <Column field="vessel" :header="$t('vesselProtocol.vessel')" sortable style="width: 150px;"></Column>
            <Column field="plant" :header="$t('vesselProtocol.plant')" sortable style="width: 150px;"></Column>
            <Column field="destination" :header="$t('vesselProtocol.destination')" sortable style="width: 150px;"></Column>
            <Column field="origin" :header="$t('vesselProtocol.countryOfOrigin')" sortable style="width: 150px;"></Column>
            
            <Column field="isRiliquidated" :header="$t('vesselProtocol.isRiliquidated')" sortable style="width: 150px;">
                <template #body="element" >
                    {{element.data.isRiliquidated ? $t('yes'): $t('no')}}
                </template>
            </Column>
            <Column field="isValueReview" :header="$t('vesselProtocol.isValueReview')" sortable style="width: 150px;">
                <template #body="element" >
                    {{element.data.isValueReview ? $t('yes'): $t('no')}}
                </template>
            </Column>
            <Column field="registerDate" :header="$t('vesselProtocol.registerDate')" sortable style="width: 150px;">
                <template #body="element" >
                    {{element.data.registerDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data.registerDate)) : null}}
                </template>
            </Column>
            <Column field="registerType" :header="$t('vesselProtocol.registerType')" sortable style="width: 150px;"></Column>
            <Column field="eRegistrationCode" :header="$t('vesselProtocol.registerNumber')" sortable style="width: 150px;"></Column>
            <Column field="arc" :header="$t('VesselProtocolTributeSearch.arc')" sortable style="width: 150px;"></Column>
            <Column field="a93Number" :header="$t('vesselProtocol.a93Number')" sortable style="width: 150px;"></Column>
            <Column field="a93Date" :header="$t('vesselProtocol.a93Date')" sortable style="width: 150px;">
                <template #body="element" >
                    {{element.data.a93Date != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data.a93Date)) : null}}
                </template>
            </Column>
            <Column field="a98Number" :header="$t('vesselProtocol.a98Number')" sortable style="width: 150px;"></Column>
            <Column field="a98Date" :header="$t('vesselProtocol.a98Date')" sortable style="width: 150px;">
                <template #body="element" >
                    {{element.data.a98Date != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data.a98Date)) : null}}
                </template>
            </Column>
            <Column field="isExecuted" :header="$t('vesselProtocol.isExecuted')" sortable style="width: 150px;">
                <template #body="element" >
                    {{element.data.isExecuted ? $t('yes'): $t('no')}}
                </template>
            </Column>
        </DataTable>
    </div>
</template>